import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Pagination from "../../../components/tablePagination/index.js";
import Search from "../../../components/search";
import Tabs from "../../../components/tabs";
import { getDeletedUsers, restoreDeletedUser } from "../../../services/admin.js";
import { filterList } from "./list.js";
import "./index.css";

var TABS = [
  { name: "Deleted Mediums" },
  { name: "Deleted Clients" },
];

var USERTYPES = [2, 3];

export default function DeletedUsers() {
  var [activeTab, setActiveTab] = useState(0);
  var [list, setList] = useState([]);
  var [totalCount, setTotalCount] = useState(0);
  var [page, setPage] = useState(1);
  var [rowsPerPage, setRowsPerPage] = useState(25);
  var [search, setSearch] = useState("");
  var [filterValues, setFilterValues] = useState("email");
  var [searchValue, setSearchValues] = useState();
  var [restoring, setRestoring] = useState(null);

  useEffect(function() {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, page, rowsPerPage, search]);

  function fetchList() {
    var params = {
      usertype: USERTYPES[activeTab],
      page: page,
      per_page: rowsPerPage,
      search: search,
    };
    getDeletedUsers(params)
      .then(function(res) {
        if (res && res.data && res.data.status) {
          setList(res.data.data.data || []);
          setTotalCount(res.data.data.total || 0);
        } else {
          setList([]);
          setTotalCount(0);
        }
      })
      .catch(function() {});
  }

  function handleTabChange(index) {
    setActiveTab(index);
    setPage(1);
    setSearch("");
  }

  function getPaginationData(data) {
    setPage(data.page);
    setRowsPerPage(data.rowsPerPage);
  }

  function handleSearch(constants) {
    var term = (constants && constants.email) || (constants && constants.screen_name) || "";
    setSearch(term);
    setPage(1);
  }

  function handleRestore(user) {
    if (restoring) return;
    setRestoring(user.id);
    restoreDeletedUser({ user_id: user.id })
      .then(function(res) {
        if (res && res.data && res.data.status) {
          toast.success(res.data.message, { position: "top-center" });
          fetchList();
        } else {
          toast.error("Failed to restore user. Please try again.", { position: "top-center" });
        }
      })
      .catch(function() {
        toast.error("Failed to restore user. Please try again.", { position: "top-center" });
      })
      .finally(function() {
        setRestoring(null);
      });
  }

  var userTypeLabel = USERTYPES[activeTab] === 2 ? "Medium" : "Client";

  return (
    <div className="all-medium-page">
      <Tabs
        active={activeTab}
        list={TABS}
        setActiveTab={handleTabChange}
      />

      <div className="d-flex justify-content-end gap-10 flex-wrap" style={{ marginBottom: 12 }}>
        <Search
          callApi={handleSearch}
          list={filterList}
          setSearchValues={setSearchValues}
          setFilterValues={setFilterValues}
          searchValue={searchValue}
          filterValues={filterValues}
        />
      </div>

      <div className="table-box-medium">
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              <th>Screen Name</th>
              <th>Email</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Type</th>
              <th>Deleted At</th>
              <th>Action</th>
            </tr>
            {list.length > 0 ? (
              list.map(function(user) {
                return (
                  <tr key={user.id} className="innr">
                    <td>{user.screen_name || user.first_name || "-"}</td>
                    <td>{user.email}</td>
                    <td>{user.first_name}</td>
                    <td>{user.last_name}</td>
                    <td>{userTypeLabel}</td>
                    <td>
                      {user.deleted_at
                        ? new Date(user.deleted_at).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })
                        : "-"}
                    </td>
                    <td>
                      <button
                        className="deleted-users-restore-btn"
                        onClick={function() { handleRestore(user); }}
                        disabled={restoring === user.id}
                      >
                        {restoring === user.id ? "Restoring..." : "Restore"}
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={7} className="text-center">
                  No deleted {userTypeLabel.toLowerCase()}s found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        rowsPerPageOptions={[10, 25, 50]}
        count={totalCount}
        activeTab={"admindetectedTimezones"}
        timezonePage={page}
        timezonerowsPerPage={rowsPerPage}
        getPaginationData={getPaginationData}
      />
    </div>
  );
}
